<div class="container-fluid px-0" id="userDetails">
    <div class="row">
        <div class="container">
            <app-user-details-header [user]="user"></app-user-details-header>
        </div>
    </div>
    <div class="row mt-3">
        <hr style="width: 100%" class="header-border" />
        <div class="container">
            <ul class="user-routes" id="homeRoutes">
                <li *ngFor="let tab of tabs; let i = index" class="list-names" (click)="selectTab(tab.value)">
                    <a [class.active]="tab.value == currentTab">
                        {{ tab.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div class="row">
        <div class="container fixed-height">
            <div class="p-0" *ngIf="isCurrentUser" [ngSwitch]="currentTab">
                <app-user-collections
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchCase="'collections'"
                ></app-user-collections>
                <app-user-catalogs
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchCase="'catalogs'"
                ></app-user-catalogs>
                <app-user-packages
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchCase="'packages'"
                ></app-user-packages>
                <app-user-following
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchCase="'following'"
                ></app-user-following>
                <app-user-groups *ngSwitchCase="'groups'"></app-user-groups>
                <app-user-details *ngSwitchDefault></app-user-details>
            </div>

            <div class="p-0" *ngIf="!isCurrentUser" [ngSwitch]="currentTab">
                <app-user-collections
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchCase="'collections'"
                ></app-user-collections>
                <app-user-catalogs
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchCase="'catalogs'"
                ></app-user-catalogs>
                <app-user-packages
                    [isCurrentUser]="isCurrentUser"
                    [username]="username"
                    *ngSwitchDefault
                ></app-user-packages>
            </div>
        </div>
    </div>
</div>
